const CATEGORY_RELATED_FILTERS = new Set([
  'Category',
  'Dosage',
  'Quantity',
  'Quantity_Total_Weight',
  'Size',
  'Weight',
]);

// This checks the filter url param to see if it is category related.
function isFilterCategoryRelated(val) {
  if (!val) {
    return false;
  }
  const valArray = val.split(/^|%5E/);
  const valKey = valArray?.[0] ?? '';

  return CATEGORY_RELATED_FILTERS.has(valKey);
}

export default isFilterCategoryRelated;
